module.exports = __webpack_public_path__ + "img/max-file-configure--xml.741b839d.svg";